<template>
    <AppHead title="Forgot Password"></AppHead>

    <div class="mb-4 text-sm text-gray-600">
        Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.
    </div>

    <div v-if="status" class="flex items-center bg-primary text-white text-sm font-bold mt-4 mb-4 px-4 py-3">
        {{ status }}
    </div>

    <BreezeValidationErrors class="mb-4" />

    <form @submit.prevent="submit">
        <div>
            <BreezeLabel for="email" value="Email" />
            <BreezeInput id="email" placeholder="Your Email Address" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
        </div>

        <div class="flex items-center justify-end mt-4">
            <app-button class="block md:w-full" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">Email Password Reset Link</app-button>
        </div>
    </form>
</template>

<script>
import AppButton from "@/Components/AppButton";
import BreezeButton from '@/Components/Button.vue'
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import BreezeInput from '@/Components/Input.vue'
import BreezeLabel from '@/Components/Label.vue'
import BreezeValidationErrors from '@/Components/ValidationErrors.vue'
import {Head} from "@inertiajs/inertia-vue3";
import AppHead from "@/Components/AppSeoTags";

export default {
    layout: BreezeGuestLayout,

    components: {
        AppHead,
        AppButton,
        BreezeButton,
        BreezeInput,
        BreezeLabel,
        BreezeValidationErrors,
        Head,
    },

    props: {
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                email: ''
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('password.email'))
        }
    }
}
</script>
